import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  partnerDetail: {
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.PartnerDetailSelect.partnerDetail`,
    defaultMessage: 'Partner Detail',
  },
});
